export default class StartButton {
    constructor(portfolioUI) {
        this.portfolioUI = portfolioUI;
        this.element = document.getElementById('startButton');
        this.isVisible = false;
        this.isDisabled = false;
        
        this.init();
    }

    init() {
        if (!this.element) return;
        
        this.bindEvents();
        this.hide();
    }

    bindEvents() {
        if (!this.element) return;
        
        this.element.addEventListener('click', () => {
            if (this.isDisabled) return;
            
            this.onClick();
        });

        // Add hover effects
        this.element.addEventListener('mouseenter', () => {
            if (this.isDisabled) return;
            this.onHover();
        });

        this.element.addEventListener('mouseleave', () => {
            if (this.isDisabled) return;
            this.onLeave();
        });
    }

    onClick() {
        // Disable the button to prevent multiple clicks
        this.disable();
        
        // Add click animation
        this.element.style.transform = 'translate(-50%, -50%) scale(0.95)';
        
        setTimeout(() => {
            this.element.style.transform = 'translate(-50%, -50%) scale(1)';
            
            // Hide the start button and show portfolio UI
            this.hide();
            
            //TODO: Show portfolio UI after a short delay. もしくは他の箇所で呼び出す。
            setTimeout(() => {
                if (this.portfolioUI) {
                    this.portfolioUI.show();
                }
            }, 300);
        }, 150);
    }

    onHover() {
        // Add extra glow effect on hover
        this.element.style.filter = `
            drop-shadow(0 0 20px rgba(255, 210, 63, 1))
            drop-shadow(0 0 30px rgba(255, 140, 66, 0.9))
            drop-shadow(0 0 40px rgba(255, 107, 53, 0.7))
            drop-shadow(0 0 50px rgba(255, 69, 0, 0.5))
        `;
    }

    onLeave() {
        // Reset to default glow
        this.element.style.filter = `
            drop-shadow(0 0 10px rgba(255, 150, 50, 0.8))
            drop-shadow(0 0 20px rgba(255, 107, 53, 0.6))
            drop-shadow(0 0 30px rgba(255, 107, 53, 0.4))
        `;
    }

    show() {
        if (!this.element) return;
        
        this.isVisible = true;
        this.isDisabled = false;
        
        this.element.classList.remove('disabled');
        this.element.style.opacity = '1';
        this.element.style.visibility = 'visible';
        this.element.style.transform = 'translate(-50%, -50%) scale(1)';
        this.element.style.pointerEvents = 'auto';
        
        // Add entrance animation
        this.element.style.animation = 'fadeInScale 0.8s ease-out';
    }

    hide() {
        if (!this.element) return;
        
        this.isVisible = false;
        
        this.element.style.opacity = '0';
        this.element.style.visibility = 'hidden';
        this.element.style.transform = 'translate(-50%, -50%) scale(0.8)';
        this.element.style.pointerEvents = 'none';
        this.element.style.animation = 'none';
    }

    disable() {
        if (!this.element) return;
        
        this.isDisabled = true;
        this.element.classList.add('disabled');
        this.element.style.pointerEvents = 'none';
        this.element.style.cursor = 'not-allowed';
    }

    enable() {
        if (!this.element) return;
        
        this.isDisabled = false;
        this.element.classList.remove('disabled');
        this.element.style.pointerEvents = 'auto';
        this.element.style.cursor = 'pointer';
    }

    // Method to reset the button (useful for development/testing)
    reset() {
        this.enable();
        this.show();
    }

    // Method to update button text
    setText(text) {
        if (!this.element) return;
        this.element.textContent = text;
    }
}

// Add keyframe for entrance animation
const style = document.createElement('style');
style.textContent = `
    @keyframes fadeInScale {
        0% {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.5);
        }
        70% {
            opacity: 0.8;
            transform: translate(-50%, -50%) scale(1.05);
        }
        100% {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
        }
    }
`;
document.head.appendChild(style);